<template>
  <div class="wrap-box">
    <WorkOrders />
  </div>
</template>

<script>
import WorkOrders from './workOrders.vue';
export default {
  name: 'GeneralOrderWorkOrders',
  components: {
    WorkOrders
  }
};
</script>

<style lang="scss" scoped>
.wrap-box{
  // overflow-y: auto;

  // height: calc(100vh - 46px);
}
</style>
